module.exports = __webpack_public_path__ + "img/cheetah-acacia.83ba625b.webp";